import React, { Fragment, useState } from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import PestaniasDesplazables from 'components/Pestanias';
import TituloConIcono from 'components/tituloConIcono';
import { LibraryBooks } from '@mui/icons-material';
import PanelDePestania from 'components/Pestanias/PanelDePestania';
import DetalleDeLaEmpresa from './DatosDeLaEmpresa';
import PersonaQueEmiteFactura from './PersonaQueEmiteFactura';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { useDispatch } from 'react-redux';
import { obtenerRegistrosPorURL } from 'store/actions/customAction';
import { functions } from 'constantes/functions';
import Base64Pdf from 'components/base64pdf';
import CaracteristicasDelMedio from './CaracteristicasDelMedio';
import DatosDelPropietario from './DatosDelPropietario';
import ObservacionesDeLaSolicitud from './ObservacionesDeLaSolicitud';
import DocumentosDeInscripcion from './DocumentosDeInscripcion';

const dataTabs = [
    {label: "Observaciones de la solicitud", icon: <LibraryBooks />, position: 0},
    {label: "Datos de la empresa", icon: <LibraryBooks />, position: 1},
    {label: "Datos del Propietario", icon: <LibraryBooks />, position: 2},
    {label: "Datos del propietario (Persona que emite factura)", icon: <LibraryBooks />, position: 3},
    {label: "Caracteristicas del medio", icon: <LibraryBooks />, position: 4},
    {label: "Carátula de Solicitud de Inscripción", icon: <LibraryBooks />, position: 5},
];

const DetalleDelRegistro = ({title, openFullScreenDialog, handleClose, datosGeneralesDeSolicitud}) => {
    const [value, setValue] = React.useState(0);
    const dispatch = useDispatch();
    const [registroDeMediosDeComunicacion] = useState("formularioDeRegistroDeMediosDeComunicacion")
    const [responseData, setResponseData] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false})
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false)
    const[datosDelDocumentoAdjunto, setDatosDelDocumentoAdjunto] = useState({title: "", pdf: ""});
    const[mostarDocumentoAdjunto, setMostrarDocumentoAdjunto] = useState(false);
    const handleChange = (_, newValue) => { setValue(newValue) };

    const closeFullScreenForm = function() { handleClose() }

    const obtenerDocumentoAdjunto = async (vista, nombreDeArchivo) => {
        setCargandoSolicitud(true);

        let respuesta = "";

        switch(vista.id){
            case 1:
            respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerArchivo/${nombreDeArchivo}`, parametro: datosGeneralesDeSolicitud?.id}));
            break;
            case 2: // personaJuridica
            respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerArchivo/personaJuridica/${nombreDeArchivo}`, parametro: datosGeneralesDeSolicitud?.id}));
            break;
            case 3: // radio
            respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerArchivo/radio/${vista?.registroId}/${nombreDeArchivo}`, parametro: ''}));
            break;
            case 4: // television
            respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerArchivo/television/${nombreDeArchivo}`, parametro: vista?.registroId || datosGeneralesDeSolicitud?.id}));
            break;
            case 5: // documentosDeInscripcion
            if (nombreDeArchivo === 'caratula') {
                respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerCaratula`, parametro: datosGeneralesDeSolicitud?.id}));
            } else if (nombreDeArchivo === 'docDePleno') {
                respuesta = await dispatch(obtenerRegistrosPorURL({controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: `obtenerJustificacionPleno`, parametro: datosGeneralesDeSolicitud?.id}));
            }
            break;
            default:
            respuesta = null
            break;
        }

        setCargandoSolicitud(false);

        if(respuesta?.error) return setResponseData({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se pudo obtener la información del documento", mostrarRespuesta: true});

        if(!respuesta?.data) return setResponseData({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No hay datos para del documento", mostrarRespuesta: true});

        setDatosDelDocumentoAdjunto({title: nombreDeArchivo, pdf: respuesta.data})
        setMostrarDocumentoAdjunto(true)
    }

    const DescargarPDF = () => functions.descargarBase64EnPDF(datosDelDocumentoAdjunto?.pdf || "", `${datosDelDocumentoAdjunto?.title || ""}.pdf`)

    const cerrarModalDelDocumento = () => setMostrarDocumentoAdjunto(false)

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setResponseData({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})
    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = responseData;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={closeFullScreenForm}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
                <TituloConIcono title={`Detalle del registro ingresado`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="registro_escritos" />
                <PestaniasDesplazables
                    handleChange={handleChange}
                    value={value}
                    tabs={dataTabs}
                >
                    <PanelDePestania value={value} index={0}>
                        <ObservacionesDeLaSolicitud datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>

                    <PanelDePestania value={value} index={1}>
                        <DetalleDeLaEmpresa datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>

                    <PanelDePestania value={value} index={2}>
                        <DatosDelPropietario datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>

                    <PanelDePestania value={value} index={3}>
                        <PersonaQueEmiteFactura datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>

                    <PanelDePestania value={value} index={4}>
                        <CaracteristicasDelMedio datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>

                    <PanelDePestania value={value} index={5}>
                        <DocumentosDeInscripcion datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
                    </PanelDePestania>
                </PestaniasDesplazables>

                {mostarDocumentoAdjunto && (
                    <Base64Pdf pdf={datosDelDocumentoAdjunto?.pdf || ""} title={datosDelDocumentoAdjunto?.title || ""} open={mostarDocumentoAdjunto} handleClose={cerrarModalDelDocumento} showDownloadButton={true} src={datosDelDocumentoAdjunto?.pdf || ""} DescargarPDF={DescargarPDF} />
                )}
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default DetalleDelRegistro;